<template>

    <v-page>

        <transition name="modal">
            <v-modal-customer-delete v-if="customer && showModal === 'delete'" :customer="customer" />
            <v-modal-customer-notes v-if="customer && showModal === 'notes'" :customer="customer" @saved="reload" />
            <v-modal-customer-tags v-if="customer && showModal === 'tags'" :customer="customer" @saved="reload" />
        </transition>

        <v-page-header icon="fas fa-id-card">
            <v-breadcrumb>
                <v-breadcrumb-item><router-link :to="{ name: 'customers' }">Customers</router-link></v-breadcrumb-item>
                <v-breadcrumb-item v-if="customer" :title="customer.name || 'Unknown'" />
            </v-breadcrumb>
        </v-page-header>

        <v-map v-if="customer" :customer="customer" />
        <v-menu v-if="customer" :customer="customer" />

        <v-page-body>
            <v-notice v-if="!customer && switchToProject" title="Customer Found in Another Project" :message="`Switch to ${switchToProject.name} to view the customer?`">
                <template #footer>
                    <v-button :loading="loading" @click.native="switchProject">Switch Project</v-button>
                </template>
            </v-notice>
            <v-notice v-else-if="!customer" title="Customer Not Found" message="Unable to find a customer with the given ID." />
            <template v-else>
                <div class="sidebar">
                    <v-widget-charges :customer="customer" />
                    <v-widget-notes :customer="customer" />
                    <v-widget-events :customer="customer" />
                    <v-widget-pages :customer="customer" />
                    <v-widget-segments :customer="customer" />
                    <v-widget-tags :customer="customer" />
                    <v-widget-traits :customer="customer" />
                    <v-widget-unsub-groups :customer="customer" />
                    <v-button class="mt-10" size="sm" btn-style="white-danger" @click.native="deleteCustomer">Delete Customer</v-button>
                </div>
                <div class="primary">
                    <router-view :customer="customer"></router-view>
                </div>
            </template>
        </v-page-body>

    </v-page>

</template>

<style scoped lang="scss">

    .sidebar {
        align-items: center;
        display: flex;
        flex-direction: column;
        float: left;
        width: 340px;
    }

    .primary {
        margin-left: 355px;
    }

</style>

<script>

import axios from 'axios';
import CustomerApi from '@api/CustomerApi';
import ModalCustomerDelete from '@modals/customer/ModalCustomerDelete';
import ModalCustomerNotes from '@modals/customer/ModalCustomerNotes';
import ModalCustomerTags from '@modals/customer/ModalCustomerTags';
import moment from 'moment';
import ProjectApi from '@api/ProjectApi';
import TheMap from './components/TheMap';
import TheMenu from './components/TheMenu';
import UserApi from '@api/UserApi';
import WidgetCharges from './components/WidgetCharges';
import WidgetEvents from './components/WidgetEvents';
import WidgetNotes from './components/WidgetNotes';
import WidgetPages from './components/WidgetPages';
import WidgetSegments from './components/WidgetSegments';
import WidgetTags from './components/WidgetTags';
import WidgetTraits from './components/WidgetTraits';
import WidgetUnsubGroups from './components/WidgetUnsubGroups';

export default {

    components: {
        'v-map': TheMap,
        'v-menu': TheMenu,
        'v-modal-customer-delete': ModalCustomerDelete,
        'v-modal-customer-notes': ModalCustomerNotes,
        'v-modal-customer-tags': ModalCustomerTags,
        'v-widget-charges': WidgetCharges,
        'v-widget-events': WidgetEvents,
        'v-widget-notes': WidgetNotes,
        'v-widget-pages': WidgetPages,
        'v-widget-segments': WidgetSegments,
        'v-widget-tags': WidgetTags,
        'v-widget-traits': WidgetTraits,
        'v-widget-unsub-groups': WidgetUnsubGroups,
    },

    data() {
        return {
            loading: false,
            customer: null,
            switchToProject: null,
        }
    },

    mounted() {
        this.$store.commit('loading', true);
        this.reload();
    },

    methods: {

        reload(projectId = null) {
            let requests = [
                ProjectApi.getProject(projectId || this.project.id),
                CustomerApi.getCustomer(this.$route.params.id),
            ];
            axios.all(requests)
                .then(axios.spread((resProject, resCustomer) => {
                    this.$store.commit('loading', false);
                    this.customer = resCustomer.data.data;
                    this.$events.$emit('pageLoaded');
                }), (error) => {
                    this.$store.commit('loading', false);
                    if (error.response.status === 406) {
                        this.switchToProject = error.response.data.message;
                        this.$events.$emit('pageLoaded');
                    } else {
                        this.$events.$emit('pageError');
                    }
                });
        },

        switchProject() {
            this.loading = true;
            UserApi.updateProject(this.switchToProject.id)
                .then((response) => {
                    this.loading = false;
                    this.reload(this.switchToProject.id);
                }, (error) => {
                    this.$store.commit('setAlertWithError', error);
                    this.loading = false;
                });
        },

        deleteCustomer() {
            this.$store.commit('showModal', 'delete');
        },

        valueForCustomAttribute(value, key) {
            if (value && key.slice(-3) === '_at') {
                return moment.unix(value).format('MM/DD/YYYY h:mm A');
            }
            return value ? value.toString() : '';
        },

    },

}

</script>
